function version(response) {
    return response.data?.build?.version || "dev";
}


export default class ActuatorService{
    constructor(axios, snackbar) {
        this.axios = axios;
        this.snackbar = snackbar;
    }

    version(paths = ["/api", "/oauth2"]) {
        return Promise.all(paths.map(path => this.axios
            .get(`${path}/actuator/info`)
            .then(version)))
            .catch(this.snackbar.catch())
            .then(values => {
                const out = {};
                for (const i in paths) {
                    const path = paths[i];
                    const value = values[i];
                    out[path] = value;
                }
                return out;
            });
    }
}
